export enum EventNames {
  GENERAL = 'general',
  TRACKING = 'tracking',
  LESSON_EVENT = 'lessonEvent',
}
